import script from "./ComHuonekorttiExpandedRow.vue?vue&type=script&setup=true&lang=ts"
export * from "./ComHuonekorttiExpandedRow.vue?vue&type=script&setup=true&lang=ts"

import "./ComHuonekorttiExpandedRow.vue?vue&type=style&index=0&id=f9b8ceae&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-f9b8ceae"]])

export default __exports__